import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { RESTApplicationResponse } from '@adgate/common/types/rest-application-response.type';
import { Creativity } from '@adgate/modules/streaming/types/creativity.type';
import { SpecCheckReportDialogComponent } from '@adgate/common/components/spec-check-report-dialog-component/spec-check-report-dialog-component';
import { DialogService } from '@adgate/common/services/dialog-service';
import { environment } from '@env/environment';
import { StreamingService } from '@adgate/modules/streaming/services/streaming-service';

@Component({
  selector: 'app-streaming-multi-upload-report-dialog-component',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatTooltip
  ],
  templateUrl: './streaming-multi-upload-report-dialog-component.html',
  styleUrl: './streaming-multi-upload-report-dialog-component.scss',
})
export class StreamingMultiUploadReportDialogComponent implements OnInit
{
  private dialogRef: MatDialogRef<StreamingMultiUploadReportDialogComponent> = inject(MatDialogRef);
  public dialogService: DialogService = inject(DialogService);
  public streamingService: StreamingService = inject(StreamingService);
  public data: RESTApplicationResponse[] = inject(MAT_DIALOG_DATA);

  ngOnInit(): void 
  {
    console.log(this.data);
  }

  onClose(): void
  {
    this.dialogRef.close();
  }

  onViewSpecCheckReport(c:Creativity)
  {
    const dialogRef = this.dialogService.openAnyDialog(SpecCheckReportDialogComponent,{
      data: {
        objectType: Creativity.OBJECT_TYPE,
        objectId: c.id,
        title: `${c.referenceCode}`,
        allowUpload: false,
        specsUrl: `${environment.helpCenterUrl}#specs-streaming`
      },
      width: '600px',
      minWidth: '600px',
      disableClose: true
    });

    // dialogRef.afterClosed().pipe(
    //   filter((result) => result != null)
    // ).subscribe((result:'upload' | 'view-specs') => {
    //   if( result === 'upload' ) {
    //     this.onUploadCreativity(c);
    //   }
    // });
  }

  // onUploadCreativity(c: Creativity): void
  // {
  //   const dialogRef = this.dialogService.openAnyDialog(UploadDialogComponent, {
  //     width: '600px',
  //     minWidth: '600px',
  //     disableClose: true
  //   });

  //   dialogRef.afterClosed().pipe(
  //     filter((result:UploadDialogResult | null) => result !== null),
  //     switchMap((result:UploadDialogResult) => {
  //       if( result.uploadMethod.id == AdGateConstants.UPLOADMETHOD_HTTP ) {
  //       return this.streamingService.uploadCreativity_HTTP(c.id, result.media);
  //       } else if( result.uploadMethod.id == AdGateConstants.UPLOADMETHOD_ASPERA ) {
  //         this.dialogService.showProgress();
  //         return this.streamingService.uploadCreativity_ASPERA(c.id, result.media);
  //       } else {
  //         return throwError(() => new Error('Invalid upload method'));
  //       }
  //     })
  //   ).subscribe({
  //     next: (r:RESTApplicationResponse) => {
  //       this.dialogService.openInfoDialog(r.message);
  //     },
  //     error: (err:Error) => {
  //       this.dialogService.openErrorDialog(err.message);
  //     }
  //   });
  // }
}
